import { render } from "./ComplainceDialog.vue?vue&type=template&id=6eb97f28"
import script from "./ComplainceDialog.vue?vue&type=script&lang=js"
export * from "./ComplainceDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__